import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Debug: afficher l'URL de l'API au chargement
console.log('🔍 UploadBalance - REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('🔍 UploadBalance - API_URL utilisée:', API_URL);

function UploadBalance({ onUploadSuccess }) {
  const [file, setFile] = useState(null);
  const [periode, setPeriode] = useState('');
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file || !periode) {
      alert('Veuillez sélectionner un fichier et saisir une période');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('periode', periode);

    try {
      const response = await axios.post(`${API_URL}/balances/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      alert(`✅ ${response.data.message}\n${response.data.lignesImportees} lignes importées`);
      
      // Réinitialiser le formulaire
      setFile(null);
      setPeriode('');
      e.target.reset();
      
      // Callback pour recharger les périodes
      if (onUploadSuccess) {
        onUploadSuccess();
      }
    } catch (error) {
      console.error('Erreur upload:', error);
      alert('❌ Erreur lors de l\'upload: ' + (error.response?.data?.error || error.message));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-container">
      <h2>📤 Importer une nouvelle balance</h2>
      <form onSubmit={handleUpload} className="upload-form">
        <div className="form-group">
          <label>Fichier Excel :</label>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            disabled={uploading}
          />
        </div>

        <div className="form-group">
          <label>Période (AAAA-MM) :</label>
          <input
            type="text"
            placeholder="Ex: 2025-01"
            value={periode}
            onChange={(e) => setPeriode(e.target.value)}
            disabled={uploading}
            pattern="\d{4}-\d{2}"
            title="Format: AAAA-MM (ex: 2025-01)"
          />
        </div>

        <button type="submit" disabled={uploading || !file || !periode}>
          {uploading ? '⏳ Import en cours...' : '🚀 Importer'}
        </button>
      </form>

      <div className="info-box">
        <strong>ℹ️ Format Excel attendu :</strong>
        <ul>
          <li>Colonne "Numéro de compte" ou "Compte" ou "N° Compte"</li>
          <li>Colonne "Libellé" ou "Libelle" ou "Description"</li>
          <li>Colonne "Montant" ou "Solde"</li>
        </ul>
      </div>
    </div>
  );
}

export default UploadBalance;
